import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _AddProductToMarketPlace, _MarketPlace } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectUBLSoftwareDispatcherByEnvironmentType } from "../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/Selectores/SelectUBLSoftwareDispatcherByEnvironmentType";
import { SoftwareDispatcherByEnvironmentType } from "./SoftwareDispatcherByEnvironmentType";
import { MarketPlaceCategory } from "./MarketPlaceCategory";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { MarketPlaceCategoryEditor } from "./MarketPlaceCategoryEditor";
import { MarketPlacePrice } from "./MarketPlacePrice";
import { InventoryCatalogByMarke } from "./InventoryCatalogByMarke";



export const MarketPlace = () => {

    const market = useDataBean(_MarketPlace);
    const addmarket = useDataBean(_AddProductToMarketPlace);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalcat, setModalcat] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmarkprod, setModalmarkprod] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallistprice, setModallistprice] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalprod, setModalprod] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        market.instance.getMarketPlaceCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.Soft = (user.DataBeanProperties.SoftwareName ?? "") + "-" + (user.DataBeanProperties.EnvironmentTypeName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        market.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        market.deleteItemVoid(market.bean.IDMarketPlace).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        market.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addProductToMarketPlace = () => {

        addmarket.instance.addProductToMarketPlace(addmarket.bean.IDProduct, market.bean.IDMarketPlace, addmarket.bean.IDMarketPlaceCategory).then(
            (resp: any) => {
                getLista();
                setModalmarkprod({ ...modalmarkprod, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDMarketPlace', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Facturador', property: 'Soft', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Categorías de Market', icono: 'ri-file-list-fill', visible: single.canEdit(), evento: () => { setModalcat({ ...modalcat, "view": true }) } },
            { titulo: 'Agregar Productos a MarketPlace', icono: 'ri-task-fill', visible: single.canEdit(), evento: () => { setModalmarkprod({ ...modalmarkprod, "view": true }) } },
            { titulo: 'Lista de Precios de MarketPlace', icono: 'ri-price-tag-3-line', visible: single.canEdit(), evento: () => { setModallistprice({ ...modallistprice, "view": true }) } },
            { titulo: 'Productos de MarketPlace', icono: 'ri-layout-grid-fill', visible: single.canEdit(), evento: () => { setModalprod({ ...modalprod, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Catálogo de MarketPlace">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={market.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={market.bean.Name} onChange={market.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <SoftwareDispatcherByEnvironmentType idSelector={market.bean.IDUBLSoftwareDispatcher} onChange={(e: any) => { market.setBean({ ...market.bean, "IDUBLSoftwareDispatcher": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <BasicSwitch label="Habilitado" estado={market.bean.Enabled} eventChange={(e: any) => { market.setBean({ ...market.bean, "Enabled": e }) }}></BasicSwitch>
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={modalcat} updateModal={setModalcat} >
                        <div className="row">
                            <MarketPlaceCategory idMarketPlace={market.bean.IDMarketPlace} />

                        </div>
                    </Modal>
                    <Modal modal={modalmarkprod} updateModal={setModalmarkprod} eventModal={addProductToMarketPlace}>
                        <div className="row">

                            <div className="row">
                                <div className="col-md-12">
                                    <MarketPlaceCategoryEditor idMarketPlace={market.bean.IDMarketPlace} idSelector={addmarket.bean.IDMarketPlaceCategory} onChange={(e) => { addmarket.setBean({ ...addmarket.bean, "IDMarketPlaceCategory": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <SelectProductEditor label="Producto" value={addmarket.bean.IDProduct} onChange={(e) => { addmarket.setBean({ ...addmarket.bean, "IDProduct": e.IDProduct }) }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modallistprice} updateModal={setModallistprice} >
                        <div className="row">
                            <MarketPlacePrice idMarketPlace={market.bean.IDMarketPlace} />
                        </div>
                    </Modal>
                    <Modal modal={modalprod} updateModal={setModalprod}>
                        <div className="row">

                            <InventoryCatalogByMarke idMarketPlace={market.bean.IDMarketPlace} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {market.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div >
        </BasicPage >
    )
}